import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/Button';
import { APP_NAME } from '../constants';
import logoImage from '../assets/logo.png';

const PageContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
`;

const Header = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #36226f;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

const Logo = styled.img`
  height: 50px;
  cursor: pointer;
  
  @media (max-width: 480px) {
    height: 40px;
  }
`;

const ContentContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 60px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 40px 15px;
  }
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  
  i {
    font-size: 40px;
    color: white;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #381f74;
  margin-bottom: 20px;
  
  @media (max-width: 480px) {
    font-size: 30px;
  }
`;

const Message = styled.p`
  font-size: 18px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.6;
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const SubMessage = styled.p`
  font-size: 16px;
  color: #888;
  margin-bottom: 40px;
  line-height: 1.6;
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
  
  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    max-width: 300px;
  }
`;

const ContactSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleContactAgain = () => {
    navigate('/contact');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>Message Sent Successfully - {APP_NAME}</title>
        <meta name="description" content="Your message has been sent successfully. We'll get back to you soon!" />
      </Helmet>
      
      <PageContainer>
        <Header>
          <Logo src={logoImage} alt="Logo" onClick={handleLogoClick} />
          <div></div> {/* Empty div for spacing */}
        </Header>
        
        <ContentContainer>
          <SuccessIcon>
            <i className='bx bx-check'></i>
          </SuccessIcon>
          
          <Title>Message Sent Successfully!</Title>
          
          <Message>
            Thank you for reaching out to us. We've received your message and will get back to you within 24 hours.
          </Message>
          
          <SubMessage>
            Our support team will review your inquiry and respond to the email address you provided.
          </SubMessage>
          
          <ButtonContainer>
            <Button
              text="Exit"
              onClick={handleGoHome}
              bgColor="#381f74"
              textColor="white"
              width="auto"
              minWidth="160px"
            />
          </ButtonContainer>
        </ContentContainer>
      </PageContainer>
    </>
  );
};

export default ContactSuccessPage;
